import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: theme => ({
    width: '100%',
    shadowColor: theme.colors.shadowColorTwo,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowRadius: 10,
    shadowOpacity: 1,
    top: '-300px',
    maxHeight: 400
  }),
  flatlist: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    marginTop: 10,
    elevation: 6,
  }),
});
